import raw from "./brandUi.en.json";
import {brandCopy} from "./brand";
export default brandCopy(raw);
